var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RadioGroup',_vm._g(_vm._b({staticClass:"n-radio-group n-flex",attrs:{"type":"button"}},'RadioGroup',_vm.attrs,false),_vm.listeners),_vm._l((_vm.mItems),function(item){return _c('Radio',{key:item.value,staticClass:"n-col-1 n-radio-group-item",attrs:{"label":item.value}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }